module.exports = ".error {\n    color: red;\n    font-size: 14px;\n    font-weight: bold;\n}"


//////////////////
// WEBPACK FOOTER
// ./client/views/request/examinee/examinee.component.css
// module id = ./client/views/request/examinee/examinee.component.css
// module chunks = main